import { viewportSlice } from 'app/stores/viewport';
import { setCanvasRect } from './modity';
export const ViewportActions = Object.assign(Object.assign({}, viewportSlice.actions), { setCanvasRect });
